import styled from "styled-components";

const Wrapper = styled.section`
  text-align: center;
  background: #d1d1d1;
  padding: 20px;
  display: flex;
  gap: 22px;
  justify-content: center;
  box-shadow: 0 1px 5px 5px rgba(0, 0, 0, 0.3);
`;

export default Wrapper;
